import PortalIdParser from 'PortalIdParser';
export const getRootUrl = () => `/workflows/${PortalIdParser.get()}`;
export const getRootEmbeddedUrl = () => `/workflows/${PortalIdParser.get()}/embedded`;

/* Index creation page */
export const getCreationUrl = isOptedIntoCreateFromCanvas => isOptedIntoCreateFromCanvas ? `/workflows/${PortalIdParser.get()}/create` : `/workflows/${PortalIdParser.get()}/platform/create`;

/* Index performance page */
export const getPerformanceUrl = ({
  flowId
}) => `/workflows/${PortalIdParser.get()}/details/${flowId}/performance`;

/* Index action logs page */
export const getActionLogsUrl = ({
  flowId
}) => `/workflows/${PortalIdParser.get()}/details/${flowId}/action-logs`;

/* Enrollment history page */
export const getEnrollmentHistoryUrl = ({
  flowId
}) => `/platform/flow/${flowId}/enrollment-history`;
export const getEnrollmentHistoryListUrl = ({
  flowId
}) => `/platform/flow/${flowId}/enrollment-history/list`;
export const getSkippedEnrollmentsListUrl = ({
  flowId
}) => `/platform/flow/${flowId}/enrollment-history/skipped`;

/* Metrics page */
export const getMetricsUrl = ({
  flowId
}) => `/platform/flow/${flowId}/metrics`;